var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[(_vm.isInviteView)?_c('invite-view'):[_c('div',{staticClass:"normal-view"},[_c('wb-logo',{attrs:{"cssStyle":{ padding: '64px 0 40px' }}}),_c('login-view',{attrs:{"channelCode":_vm.channelCode}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }